import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth.module';
import users from './users.module';
import accesos from './accesos.module';
import capturaAccesos from './captura_accesos.module';
import capturaResidentes from './captura_residentes.module';
import capturaViviendas from './captura_viviendas.module';
import historico from './historico.module';
import historicoObras from './historico_obras.module';
import capturaColaboradores from './captura_colaboradores.module';
import preRegistro from './pre_registro.module';
import historicoPreRegistro from './historico_pre_registro.module';
import accesosColaboradores from './accesos_colaboradores.module';
import historicoAccesosColaboradores from './historico_accesos_colaboradores.module';
import rh from './rh.module';
import vacaciones from './vacaciones.module';
import turnosDobles from './turnos_dobles.module';
import inasistencias from './inasistencias.module';
import incapacidades from './incapacidades.module';
import porticos from './porticos.module';
import detallesPortico from './detalles_portico.module';
import listadoColaboradores from './listado_colaboradores.module';
import detallesColaborador from './detalles_colaborador.module';
import descansos from './descansos.module';
import incidencias from './incidencias.module';
import formaciones from './formacion.module';
import desempenios from './desempenio.module';
import avisos from './avisos.module';
import detallesAviso from './avisos_detalle.module';
import reglamentos from './reglamentos.module';
import listadoDomesticos from './listado_domesticos.module';
import detallesDomestico from './detalles_domestico.module';
import capturaDomesticos from './captura_domesticos.module';
import busquedaTelefonoResidente from './busqueda_telefono_residente.module';
import capturaMascotas from './captura_mascotas.module';
import listadoMascotas from './listado_mascotas.module';
import detallesMascota from './detalles_mascota.module';
import listadoLicencias from './listado_licencias.module';
import detallesLicencia from './detalles_licencia.module';
import capturaLicencias from './captura_licencias.module';
import listadoVehiculos from './listado_vehiculos.module';
import detallesVehiculo from './detalles_vehiculo.module';
import capturaVehiculos from './captura_vehiculos.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    users,
    accesos,
    capturaAccesos,
    capturaResidentes,
    capturaViviendas,
    historico,
    capturaColaboradores,
    preRegistro,
    historicoPreRegistro,
    accesosColaboradores,
    historicoAccesosColaboradores,
    historicoObras,
    rh,
    vacaciones,
    incapacidades,
    inasistencias,
    descansos,
    porticos,
    detallesPortico,
    listadoColaboradores,
    detallesColaborador,
    turnosDobles,
    incidencias,
    formaciones,
    desempenios,
    avisos,
    detallesAviso,
    reglamentos,
    listadoDomesticos,
    detallesDomestico,
    capturaDomesticos,
    busquedaTelefonoResidente,
    capturaMascotas,
    listadoMascotas,
    detallesMascota,
    listadoLicencias,
    detallesLicencia,
    capturaLicencias,
    listadoVehiculos,
    detallesVehiculo,
    capturaVehiculos,
  },
});
